import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import constants from "../util/Constants";
import { getClientById, getShortenClientById, updateClient } from "../../../service/tenant/ClientService";
import ErrorMessageChip from "../util/ErrorMessageChip";
import InputComponent from "../util/InputComponent";
import { getTenantLocalStorage } from "../../../service/tenant/TenantService";
import { validateClient, validateShortenClient } from "../../../service/tenant/ValidationService";

const EditClientContact = (props) => {

    const tenant = getTenantLocalStorage();
    const tenantId = tenant.id;

    const[client, setClient] = useState(null);
    const [errorMessageDialog, setErrorMessageDialog] = useState('');

    useEffect( () => {

        if( props.clientId != null && props.clientId != '' ){

            getShortenClientById(props.clientId, tenantId).then( clientResponse => {
                
                setClient(clientResponse);

            });

        } else {

            setClient(null);

        }

    }, [props.clientId] );

    const handleChangeUserAttribute = (attributeName, attributeValue) => {
        if( client ){
            
            const userAux = { ...client.user };
            userAux[attributeName] = attributeValue;
            const clientAux = { ...client, user: userAux };
            setClient(clientAux);
            
        }
    }

    const handleSaveClient = () => {
        console.debug('[EditClientContact][handleSaveClient] ...');

        setErrorMessageDialog('');
        props.setSuccessMessage('');

        const isValidUser = validateShortenClient(client);

        if( isValidUser  ){
            
            props.setIsLoading(true);

            updateClient(client, tenantId).then( clientResponse => {

                if( clientResponse != null ){
                    //console.debug('[EditClientContact][handleSaveClient] clientResponse: ', clientResponse);
                    setClient(clientResponse);
                    props.setSuccessMessage(constants.errors.editClientSuccess);

                    props.handleCloseClientDialog();

                    if( props.handleRefreshClientList != null ){
                        props.handleRefreshClientList();
                    }

                } else {
                    setErrorMessageDialog(constants.errors.editClientError)
                }

                props.setIsLoading(false);
            });

            
        } else {
            setErrorMessageDialog(constants.errors.validationErrorRequiredFields);
        }

        
    }

    return(
        <Dialog
            open={props.openClientDialog}
            onClose={props.handleCloseClientDialog}
            key="editClientContact"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                sx={constants.styles.textNormal}
                id="alert-dialog-title"
            >
                <strong>Edit client</strong>
            </DialogTitle>
            <DialogContent>
                    <Grid container >
                        <Grid item sx={constants.styles.sectionTitle} xs={12} md={12}>
                            <Grid container direction="row" spacing={0}
                                justifyContent={'left'}
                            >
                                <Grid sx={constants.styles.sectionError} item xs={12} md={12}>
                                    <ErrorMessageChip message={errorMessageDialog} />
                                </Grid>

                                <Grid item sx={constants.styles.sectionInput} xs={12} md={12}>
                                    { client ? client.user.first_name + ' ' + client.user.last_name : '' }
                                </Grid>
                                
                                <Grid item sx={constants.styles.sectionDivider}  xs={12} md={12}>
                                    <Divider/>
                                </Grid>

                                <InputComponent 
                                    fieldName={"Email"} 
                                    fieldValue={ client ? client.user.email: '' } 
                                    fieldId={'input-client-email'} 
                                    attributeName={'email'} 
                                    handleChangeField={handleChangeUserAttribute} 
                                    required={true}
                                    emailValidation={true}
                                />
                                <InputComponent 
                                    fieldName={"Phone"} 
                                    fieldValue={ client ? client.user.phone: '' } 
                                    fieldId={'input-client-phone'} 
                                    attributeName={'phone'} 
                                    handleChangeField={handleChangeUserAttribute} 
                                    required={true}
                                    phoneValidation={true}
                                />

                            </Grid>
                        </Grid>
                    </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    variant="outlined" 
                    size="small"
                    sx={constants.styles.buttonNormal}
                    onClick={props.handleCloseClientDialog}
                >
                    Cancel
                </Button>
                <Button 
                    variant="outlined" 
                    size="small"
                    sx={constants.styles.buttonNormal}
                    onClick={handleSaveClient} 
                    autoFocus
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
        
    );

}

export default EditClientContact;